<script>
  import Clipboard from 'clipboard';

  export default {
    props: {
      text: {
        type: String,
        required: true,
      },
    },

    data: () => ({
      copied: false,
    }),

    mounted () {
      const clipboard = new Clipboard(this.$el, {
        text: () => this.text,
      });

      clipboard.on('success', () => {
        this.copied = true;

        setTimeout(() => this.copied = false, 2000);
      });

      clipboard.on('error', console.log);

      this.$once('hook:beforeDestroy', () => clipboard.destroy());
    },

    render (createElement) {
      return this.$scopedSlots.default({
        copied: this.copied,
      });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Copy.vue